module.exports = __webpack_public_path__ + "img/one.bb41f6fc.png";